import React, {Component} from 'react';
import {Button, Col, Form, FormControl, FormGroup, Modal, OverlayTrigger, Popover, Row} from 'react-bootstrap';
import {connect} from 'react-redux';
import {Redirect, withRouter} from 'react-router-dom';
import {delete_folder, delete_folder_resource, fetch_folders, rename_folder} from './actions';
import {toastr} from 'react-redux-toastr';
import Select from 'react-select';
import Autosuggest from 'react-autosuggest';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';
import ContextMenu from '../../components/contextMenu';
import ImageBox from "../../components/ImageBox";
import ShareLinkModal from '../../components/ShareLinkModal';

import './style.css';
import {fetch_owned_designs} from "../Dashboard/actions";

import {MoveToFolderModal} from "./commons/MoveToFolderModal";
import {DeleteDesignModal} from "./commons/DeleteDesignModal";
import DownloadAllDesignsModal from "./DownloadAllDesignsModal";


const FolderIcons = ({folder_name, folder_id, role, on_click_fn, folder_context_menu}) => (
    <div key={folder_id} className="folder_icon"
         style={{'width': '275px', 'height': '72px', 'cursor': 'pointer', 'padding': '10px'}}
         onClick={() => on_click_fn('folders/' + folder_id + '/' + role)}>
        {(role === 'edit' && folder_context_menu) ? (
            <ContextMenu contextMenuName="folder-context-menu" contextMenuOptions={folder_context_menu}/>) : ''}
        <img style={{'paddingRight': '10px'}}
             src="https://img.icons8.com/cotton/64/000000/folder-invoices--v1.png"/><span
        style={{'fontSize': '1.4rem', 'fontWeight': '500'}}>{folder_name?(folder_name.length < 25 ? folder_name : folder_name.substring(0, 22) + '...'):''}</span>
    </div>
);

const MyDesignsFolderIcon = ({on_click_fn}) => (
    <div className="folder_icon"
         style={{'width': '275px', 'height': '72px', 'cursor': 'pointer', 'padding': '10px'}}
         onClick={on_click_fn}>
        <img style={{'paddingRight': '10px'}}
             src="https://img.icons8.com/cotton/64/000000/folder-invoices--v1.png"/><span
        style={{'fontSize': '1.5rem', 'fontWeight': '500'}}>{"My Designs"}</span>
    </div>
);

const ErrorPage = <center style={{'fontSize': '5rem', 'fontWeight': '700', 'marginTop': 'calc(40%)'}}>Oops the resource
    does not exist.</center>;


class Folders extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            redirect_url: null,
            selectedFiles: [],
            loaded: 0,
            display_create_folder_modal: false,
            display_create_design_folder_modal: false,
            share_emails: [],
            share_role: 'view',
            last_email: '',
            folder_permissions: 'edit',
            error_page: false,
            folders: [],
            protectedFolders: [],
            display_rename_folder_modal: false,
            display_delete_folder_modal: false,
            display_share_folder_modal: false,
            selected_folder: null,
            activeDesign: null,
            displayDownloadAllDesignsModal: false,
            show_share_modal: false,
        }
    }

    set_state = async state => new Promise(resolve => this.setState(state, resolve));

    hideDownloadAllDesignsModal = () => {
        this.setState({displayDownloadAllDesignsModal: false});
    };


    handle_share_emails = share_emails => {
        this.setState({share_emails: share_emails, last_email: ''})
    };

    handle_last_email = input => {
        this.setState({last_email: input})
    };

    update_inputs = (event) => {
        this.setState({[event.target.name]: event.target.value})
    };

    update_inputs_enter = (type) => {
        if (this.state.folder_name !== "") {
            this.create_new_folder(type)
        }
    };

    toggle_overlay = () => {
        if (window.document.getElementById('popover_overlay_share').style.display === "none") {
            window.document.getElementById('popover_overlay_share').style.display = "block"
        } else {
            window.document.getElementById('popover_overlay_share').style.display = "none"
        }
    };

    send_invites = (folder_id, close_popover = true) => {
        let emails = this.state.share_emails;
        if (this.state.last_email) {
            emails.push(this.state.last_email)
        }
        if (emails.length > 0 && this.state.share_role) {

            const url = global.config.server_path + 'folder/share';
            const payload = {
                'host_email': this.props.user.email,
                'emails': emails,
                'folder_id': folder_id,
                'role': this.state.share_role
            };

            fetch(url, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                'credentials': 'include',
                body: JSON.stringify(payload)
            })
                .then(resp => {
                    toastr.success('Shared folder successfully!')
                })
                .catch(err => {
                    toastr.error('Failed to share folder.')
                });
            if (close_popover) window.document.getElementById('overlay_button_share').click()
        }
    };

    componentDidMount() {
        fetch_folders()
            .then(data => data.json())
            .then(data => {

                let protectedFolders = [];

                if (this.props.user && this.props.user.my_photos_folder) protectedFolders.push(this.props.user.my_photos_folder);
                if (this.props.user && this.props.user.my_designs_folder) protectedFolders.push(this.props.user.my_designs_folder);
                if (this.props.user && this.props.user.my_purchases_folder) protectedFolders.push(this.props.user.my_purchases_folder);

                this.setState({
                    folders: data.data,
                    protectedFolders: protectedFolders
                })

            })
            .catch(err => {
                toastr.error("Something went wrong :/");
                console.error("Error fetching folders: ", err);
            });
    }

    isProtectedFolder = (folderId) => {
        return this.state.protectedFolders.includes(folderId);
    };

    generate_folder_buttons = ({type, has_context_menu = true}) => (
        this.state.folders.filter(element => element['folder']['type'] === type)
            .map((element, idx) => {
                if (element['ownership'] === 'shared') {
                    return <FolderIcons folder_name={element['folder'].name} folder_id={element['folder']._id}
                                        role={element.role} on_click_fn={this.redirect_page}/>
                } else if (element['folder']._id === this.props.user.my_designs_folder) return <MyDesignsFolderIcon
                    on_click_fn={() => this.redirect_page("/designmaker/start/all-designs")}/>;
                else if (this.isProtectedFolder(element['folder']._id)) {
                    if (element['folder']._id === this.props.user.my_photos_folder) {
                        const contextMenuBtns = [
                            {
                                'name': 'Share',
                                'action': ((e) => {
                                    e.stopPropagation();
                                    this.setState({
                                        selected_folder: element['folder']._id,
                                        display_share_folder_modal: true
                                    })
                                })
                            }
                        ];
                        return <FolderIcons folder_name={element['folder'].name} folder_id={element['folder']._id}
                                            role={element.role} on_click_fn={this.redirect_page}
                                            folder_context_menu={contextMenuBtns}/>
                    } else {
                        return <FolderIcons folder_name={element['folder'].name} folder_id={element['folder']._id}
                                            role={element.role} on_click_fn={this.redirect_page}/>
                    }
                } else {
                    let contextMenuBtns = [
                        {
                            'name': 'Share',
                            'action': ((e) => {
                                e.stopPropagation();
                                this.setState({
                                    selected_folder: element['folder']._id,
                                    display_share_folder_modal: true
                                })
                            })
                        },
                        {
                            'name': 'Rename',
                            'action': ((e) => {
                                e.stopPropagation();
                                this.setState({
                                    selected_folder: element['folder']._id,
                                    display_rename_folder_modal: true
                                })
                            })
                        },
                        {
                            'name': 'Delete',
                            'action': ((e) => {
                                e.stopPropagation();
                                this.setState({
                                    display_delete_folder_modal: true,
                                    selected_folder: element['folder']._id
                                })
                            })
                        }
                    ];
                    return <FolderIcons folder_name={element['folder'].name} folder_id={element['folder']._id}
                                        role={element.role} on_click_fn={this.redirect_page}
                                        folder_context_menu={contextMenuBtns}/>
                }
            })
    );


    redirect_page = (url) => {
        this.setState({redirect_url: url, redirect: true})
    };

    design_folder_on_click_handler = (design) => {
        console.log("triggered", design)
        this.redirect_page('/designmaker/start/designs/' + design._id + '/' + design.role)
    };

    create_new_folder = (folder_type) => {
        const url = global.config.server_path + 'folder/create';
        fetch(url, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            'credentials': 'include',
            'body': JSON.stringify({'folder_name': this.state.folder_name, 'folder_type': folder_type})
        })
            .then(res =>
                this.setState({
                    display_create_folder_modal: false,
                    display_create_design_folder_modal: false
                })
            )
            .then(() => fetch_folders())
            .then(data => data.json())
            .then(data => {
                this.setState({
                    folders: data.data
                })
            })
            .catch((err) => {
                toastr.error("Something went wrong :/");
                console.error('Error fetching folders: ', err);
            })
    };

    file_upload_handler = event => {
        this.setState({
                selectedFiles: event.target.files,
                loaded: 0,
            },
            () => {
                if (this.state.selectedFiles && this.state.selectedFiles.length > 0) {
                    this.onClickHandler();
                }
            }
        )
    };

    onClickHandler = () => {
        const data = new FormData();
        this.state.selectedFiles.forEach(file => {
            data.append('file', file, file.name)
        });
        data.append('folder_id', this.props.match.params.folder_id)
        const url = global.config.server_path + 'folder/upload_multiple_files';
        fetch(url, {method: 'POST', 'credentials': 'include', body: data})
            .then(() => {
                this.setState({
                    selectedFiles: []
                })
                fetch_folders()
                    .then(data => data.json())
                    .then(data => {
                        this.setState({
                            folders: data.data
                        })
                    })
                    .catch((err) => {
                            console.log('Error fetching folders');
                        }
                    )
            })
            .then(() => toastr.success("Files uploaded"));
    };

    generate_thumbnails_context_menu = (resource) => {
        let resource_path = null;
        if (resource._id) resource_path = resource._id;
        else if (resource.src) resource_path = resource.src;


        const designs_context_menu = [
            {
                'name': 'Remove from folder',
                'action': (e => {
                    this.delete_folder_resource(resource_path);
                })
            }
        ];

        return (<ContextMenu contextMenuName="your-designs-context-menu" contextMenuOptions={designs_context_menu}/>)
    };

    generateDesignThumbnailsContextMenu = (resource) => {
        let resource_path = null;
        if (resource._id) resource_path = resource._id;
        else if (resource.src) resource_path = resource.src;

        const designs_context_menu = [
            {
                'name': 'Move to Folder',
                'action': (e => {
                    this.setState({displayFolderModal: true, activeDesign: resource._id});
                })
            }, {
                'name': 'Remove from folder',
                'action': (e => {
                    this.delete_folder_resource(resource_path);
                })
            }, {
                name: 'Share',
                action: e => {
                    e.stopPropagation();
                    this.setState({ 'show_share_modal': true, activeDesign: resource_path })
                    // this.activate_share_modal({ design_id: design._id, is_saved_design: true });
                }
            }
        ];

        return (<ContextMenu contextMenuName="your-designs-context-menu" contextMenuOptions={designs_context_menu}/>)
    };

    delete_folder_resource = (resource_id) => {
        delete_folder_resource(this.props.match.params.folder_id, resource_id)
            .then(() => fetch_folders())
            .then(data => data.json())
            .then(data => {
                this.setState({
                    folders: data.data
                })
            })
            .catch((err) => {
                console.error('Error fetching folders', err);
            })
    }


    FolderView = () => {

        if (this.state.folders && this.props.match.params.folder_id) {
            const share_options = [{value: 'view', label: 'Can View'}, {value: 'edit', label: 'Can Edit'}];
            const user_options = []

            function autocompleteRenderInput({addTag, ...props}) {
                const handleOnChange = (e, {newValue, method}) => {
                    if (method === 'enter') {
                        e.preventDefault()
                    } else {
                        props.onChange(e)
                    }
                }

                const inputValue = (props.value && props.value.trim().toLowerCase()) || ''
                const inputLength = inputValue.length

                let suggestions = user_options.filter((user) => {
                    return user.name.toLowerCase().slice(0, inputLength) === inputValue
                })

                return (
                    <Autosuggest
                        ref={props.ref}
                        suggestions={suggestions}
                        shouldRenderSuggestions={(value) => value && value.trim().length > 0}
                        getSuggestionValue={(suggestion) => suggestion.name}
                        renderSuggestion={(suggestion) => <span>{suggestion.name}</span>}
                        inputProps={{...props, onChange: handleOnChange}}
                        onSuggestionSelected={(e, {suggestion}) => {
                            addTag(suggestion.name)
                        }}
                        onSuggestionsClearRequested={() => {
                        }}
                        onSuggestionsFetchRequested={() => {
                        }}
                    />
                )
            }

            const folder_id = this.props.match.params.folder_id;
            let curr_folder = this.state.folders.filter(element => element['folder']['_id'] === folder_id);
            if (!curr_folder.length) {
                return <center style={{'fontSize': '5rem', 'fontWeight': '700', 'marginTop': 'calc(40%)'}}/>
            }
            curr_folder = curr_folder[0];
            const current_folder_data = curr_folder['folder'];

            const share_popover = (
                <Popover id="share_popover" className="share_popover">
                    <div>
                        <TagsInput renderInput={autocompleteRenderInput} value={this.state.share_emails}
                                   inputValue={this.state.last_email}
                                   inputProps={{placeholder: "Type one or more emails"}}
                                   onChange={this.handle_share_emails} onChangeInput={this.handle_last_email}/>
                        <Select options={share_options} defaultValue={share_options[0]} onChange={(e) => {
                            this.setState({share_role: e.value})
                        }}/>
                        <Button type="button" onClick={(() => {
                            this.send_invites(folder_id)
                        })} className="popover-button-custom" style={{'width': '100%'}} type="submit">Send
                            Invites</Button>
                    </div>
                </Popover>
            );

            if (current_folder_data['type'] === 'design' || current_folder_data['type'] === 'photo') {
                let folder_resources = [];
                if (current_folder_data['type'] === 'design' && this.props.saved_designs) {
                    folder_resources = current_folder_data['resources'].map(element => ({
                        src: "uploads/design_resources/design_thumbnails/" + element.path + ".jpg",
                        _id: element.path,
                        role: curr_folder.role
                    }));
                } else {
                    folder_resources = current_folder_data['resources'].map(element => ({
                        src: element.path,
                        low_src: element.low_path
                    }));
                }

                return (
                    <div>
                        <div style={{'paddingTop': '30px'}}>
                            <Row style={{cursor: 'pointer'}}
                                 onClick={() => this.redirect_page('/designmaker/start/folders')}>
                                <span style={{color: 'grey', fontWeight: 'bold'}} className="fa fa-arrow-left"/>
                                <span style={{marginLeft: 5}}> Back</span>
                            </Row>
                            <span
                                style={{'fontSize': '2.8rem', 'fontWeight': '700'}}>{current_folder_data['name']}</span>
                            <span>
                            {(curr_folder['ownership'] === 'owned' && !this.isProtectedFolder(current_folder_data['_id'])) ? (
                                <OverlayTrigger trigger="click" placement="bottom" overlay={share_popover}>
                                    <Button id="overlay_button_share" className="btn-orange"
                                            style={{marginRight: '5px', float: 'right'}}
                                            onClick={this.toggle_overlay}>Share</Button>
                                </OverlayTrigger>) : null}
                                <Button style={{float: 'right', marginRight: 5}}
                                        className={"btn btn-orange"}
                                        onClick={() => this.setState({displayDownloadAllDesignsModal: true})}><span className="fa fa-download"/></Button>
                                {(current_folder_data['type'] === 'photo' && this.props.match.params.role === 'edit') ?
                                    <Button className="btn-orange" style={{marginRight: '5px', float: 'right'}}
                                            onClick={() => {
                                                window.document.getElementById('upload_file').click()
                                            }}>Upload</Button> : ''}
                                {(current_folder_data['type'] === 'photo' && this.props.match.params.role === 'edit') ?
                                    <input id="upload_file" style={{'float': 'right', display: 'none'}} type="file"
                                           name="file" onChange={this.file_upload_handler} multiple accept=".png, .jpg, .jpeg"/> : ''}
                            </span>
                        </div>
                        {/* <DesignResourcesPanel */}
                        {/*     on_drag_start={() => { */}
                        {/*     }} */}
                        {/*     on_drag_end={() => { */}
                        {/*     }} */}
                        {/*     on_click={(current_folder_data.type === 'design') ? this.design_folder_on_click_handler : (() => { */}
                        {/*     })} */}
                        {/*     resources={folder_resources} */}
                        {/*     image_height={'200px'} */}
                        {/*     showContextMenu={curr_folder['ownership'] === 'owned'} */}
                        {/*     contextMenu={current_folder_data['type'] === 'photo' ? this.generate_thumbnails_context_menu : this.generateDesignThumbnailsContextMenu} */}
                        {/* /> */}
                        {folder_resources.map((element, idx) => (
                            <ImageBox
                                key={'folder-resource-' + element._id}
                                idx={idx}
                                image_src={global.config.static_file_server_path + element.src}
                                // name={element.name}
                                disable_overlay={true}
                                image_style={{
                                    maxWidth: 148,
                                    maxHeight: 173,
                                    height: 'unset',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    objectFit: 'contain',
                                    display: 'block',
                                    boxShadow: '0 0 8px 0 rgba(66,66,66,0.5)'
                                }}
                                container_style={{width: 165}}
                                // footer_text={element.name}
                                context_menu={((e) => {
                                    if(curr_folder['ownership'] === 'owned'){
                                        return current_folder_data['type'] === 'photo' ? this.generate_thumbnails_context_menu(element) : this.generateDesignThumbnailsContextMenu(element)
                                    }else{
                                        return ''
                                    }
                                })()}
                                on_click={() => {if(current_folder_data.type === 'design'){this.design_folder_on_click_handler(element)} } }
                                skeleton={true}
                                skeleton_width={160}
                                skeleton_height={185}
                                boxed_view={true}
                                max_container_height={185}
                            />
                        ))}
                    </div>
                )
            }
        }
    };

    FolderHomeView = () => (
        <div>
            <div style={{'fontSize': '3.2rem', 'fontWeight': '700', marginTop: 50, marginBottom: 25}}>Folders</div>
            <div>
                <span style={{'fontSize': '2.4rem', 'fontWeight': '700'}}>Photo Folders</span>
                <Button style={{'float': 'right', 'marginRight': '15px', 'background': 'none', 'border': 'none'}}
                        onClick={() => {
                            this.setState({display_create_folder_modal: true})
                        }}>+ Create new</Button>
            </div>
            <div style={{'paddingTop': '10px', 'paddingBottom': '10px', 'display': 'flex', 'flexFlow': 'wrap'}}>
                {this.state.folders ? <this.generate_folder_buttons type={'photo'}/> : null}
            </div>
            <div style={{marginTop: 50}}>
                <span style={{'fontSize': '2.4rem', 'fontWeight': '700'}}>Design Folders</span>
                <Button style={{'float': 'right', 'marginRight': '15px', 'background': 'none', 'border': 'none'}}
                        onClick={() => {
                            this.setState({display_create_design_folder_modal: true})
                        }}>+ Create new</Button>
            </div>
            <div style={{'paddingTop': '10px', 'paddingBottom': '10px', 'display': 'flex', 'flexFlow': 'wrap'}}>
                {this.state.folders ? <this.generate_folder_buttons type={'design'}/> : null}
            </div>
        </div>
    );

    CreateFolderModal = () => (
        <Modal show={this.state.display_create_folder_modal}
               onHide={() => this.setState({display_create_folder_modal: false})}>
            <Modal.Header closeButton>
                <Modal.Title style={{fontFamily: 'Montserrat', fontWeight: 800}}>Create a photo folder</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span>Folder name</span>
                <FormGroup controlId="formHorizontalName" style={{marginTop: 10}}>
                    <FormControl required value={this.state.folder_name ? this.state.folder_name : ''} type="text"
                                 onKeyDown={(e) => {
                                     if (e.key === 'Enter') {
                                         this.update_inputs_enter('photo')
                                     }
                                 }}
                                 onChange={event => this.update_inputs(event)} name="folder_name"
                                 placeholder="Folder name"/>
                </FormGroup>

            </Modal.Body>
            <Modal.Footer>
                <Button type="button" onClick={() => this.create_new_folder('photo')} className="btn-orange"
                        style={{fontFamily: 'Montserrat'}}>Create folder</Button>
            </Modal.Footer>
        </Modal>
    );

    CreateDesignFolderModal = () => (
        <Modal show={this.state.display_create_design_folder_modal}
               onHide={() => this.setState({display_create_design_folder_modal: false})}>
            <Modal.Header closeButton>
                <Modal.Title style={{fontFamily: 'Montserrat', fontWeight: 800}}>Create a design folder</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span>Folder name</span>
                <FormGroup controlId="formHorizontalName" style={{marginTop: 10}}>
                    <FormControl required value={this.state.folder_name ? this.state.folder_name : ''} type="text"
                                 onKeyDown={(e) => {
                                     if (e.key === 'Enter') {
                                         this.update_inputs_enter('design')
                                     }
                                 }} onChange={event => {
                        this.update_inputs(event)
                    }} name="folder_name" placeholder="Folder name"/>

                </FormGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button type="button" style={{fontFamily: 'Montserrat'}} onClick={() => {
                    this.create_new_folder('design')
                }} className="btn-orange">Create folder</Button>
            </Modal.Footer>
        </Modal>
    );

    RenameFolderModal = () => (
        <Modal show={this.state.display_rename_folder_modal}
               onHide={() => this.setState({display_rename_folder_modal: false})}>
            <Modal.Header closeButton>
                <Modal.Title style={{fontFamily: 'Montserrat', fontWeight: 800}}>Rename folder</Modal.Title>
            </Modal.Header>
            <Form horizontal
                  onSubmit={(e) => {
                      e.preventDefault();
                      rename_folder(this.state.selected_folder, this.state.folder_name)
                          .then(() => this.set_state({display_rename_folder_modal: false}))
                          .then(() => fetch_folders())
                          .then(data => data.json())
                          .then(data => {
                              this.setState({
                                  folders: data.data
                              })
                          })
                          .catch(err => console.log(err));
                  }
                  }
            >
                <Modal.Body>
                    <span>Folder name</span>
                    <FormGroup controlId="formHorizontalName">
                        <Col style={{'marginTop': '10px'}} sm={12} style={{fontFamily: 'Montserrat'}}>
                            <FormControl required value={this.state.folder_name ? this.state.folder_name : ''}
                                         type="text" onChange={event => this.update_inputs(event)} name="folder_name"
                                         placeholder="Folder name"/>
                        </Col>
                    </FormGroup>

                </Modal.Body>
                <Modal.Footer>
                    <Button type="submit" className="btn-orange" style={{fontFamily: 'Montserrat'}}>Rename
                        folder</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );

    DeleteFolderModal = () => (
        <Modal show={this.state.display_delete_folder_modal}
               onHide={() => this.setState({display_delete_folder_modal: false})}>
            <Modal.Header closeButton>
                <Modal.Title style={{fontFamily: 'Montserrat', fontWeight: 800}}>Delete folder</Modal.Title>
            </Modal.Header>
            <Form horizontal onSubmit={(e) => {
                e.preventDefault();
                delete_folder(this.state.selected_folder)
                    .then(() => this.set_state({display_delete_folder_modal: false}))
                    .then(() => fetch_folders())
                    .then(data => data.json())
                    .then(data => {
                        this.setState({
                            folders: data.data
                        })
                    })
                    .catch(err => console.log(err));
            }

            }>
                <Modal.Body>
                    <span style={{fontFamily: 'Montserrat'}}>Are you sure you want to delete this folder? </span>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn-orange-inverse"
                            onClick={() => this.setState({display_delete_folder_modal: false})}>No</Button>
                    <Button type="submit" className="btn-orange-inverse" style={{fontFamily: 'Montserrat'}}>Yes</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );

    render() {

        let {redirect, redirect_url} = this.state;

        if (redirect) {
            return (<Redirect push to={redirect_url}/>)
        }

        const share_options = [{value: 'view', label: 'Can View'}, {value: 'edit', label: 'Can Edit'}];

        const user_options = []

        function autocompleteRenderInput({addTag, ...props}) {
            const handleOnChange = (e, {newValue, method}) => {
                if (method === 'enter') {
                    e.preventDefault()
                } else {
                    props.onChange(e)
                }
            };

            const inputValue = (props.value && props.value.trim().toLowerCase()) || ''
            const inputLength = inputValue.length

            let suggestions = user_options.filter((user) => {
                return user.name.toLowerCase().slice(0, inputLength) === inputValue
            });

            return (
                <Autosuggest
                    ref={props.ref}
                    suggestions={suggestions}
                    shouldRenderSuggestions={(value) => value && value.trim().length > 0}
                    getSuggestionValue={(suggestion) => suggestion.name}
                    renderSuggestion={(suggestion) => <span>{suggestion.name}</span>}
                    inputProps={{...props, onChange: handleOnChange}}
                    onSuggestionSelected={(e, {suggestion}) => {
                        addTag(suggestion.name)
                    }}
                    onSuggestionsClearRequested={() => {
                    }}
                    onSuggestionsFetchRequested={() => {
                    }}
                />
            )
        }

        const share_folder_modal = (
            <Modal show={this.state.display_share_folder_modal}
                   onHide={() => this.setState({display_share_folder_modal: false})}>
                <Modal.Header closeButton>
                    <Modal.Title style={{fontFamily: 'Montserrat', fontWeight: 800}}>Share folder</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <TagsInput renderInput={autocompleteRenderInput} value={this.state.share_emails}
                                   inputValue={this.state.last_email}
                                   inputProps={{placeholder: "Type one or more emails"}}
                                   onChange={this.handle_share_emails} onChangeInput={this.handle_last_email}/>
                        <Select options={share_options} defaultValue={share_options[0]} onChange={(e) => {
                            this.setState({share_role: e.value})
                        }}/>
                        <Button type="button" onClick={(() => {
                            this.send_invites(this.state.selected_folder, false);
                            this.setState({display_share_folder_modal: false})
                        })} className="popover-button-custom" style={{'width': '100%'}} type="submit">Send
                            Invites</Button>
                    </div>
                </Modal.Body>
            </Modal>
        );

        return (
            this.state.error_page ?
                ErrorPage :
                (<div>
                        <div id="popover_overlay_share" style={{
                            top: 0,
                            left: 0,
                            position: "fixed",
                            zIndex: "1000",
                            height: "100%",
                            width: "100%",
                            display: "none"
                        }} onClick={() => document.getElementById('overlay_button_share').click()}/>
                        {share_folder_modal}
                        <MoveToFolderModal show={this.state.displayFolderModal}
                                           onHide={() => this.setState({displayFolderModal: false, activeDesign: null})}
                                           folders={this.state.folders}
                                           omitFolders={this.props.user?[this.props.user.my_designs_folder]:[]}
                                           activeDesign={this.state.activeDesign ? this.state.activeDesign : this.state.selectedDesigns}
                                           refreshFolders={() => fetch_folders().then(res => res.json()).then(data => this.setState({folders: data.data})).catch(() => toastr.error("Something went wrong"))}/>
                        <DeleteDesignModal show={this.state.displayDeleteDesignModal}
                                           onHide={() => this.setState({
                                               displayDeleteDesignModal: false,
                                               activeDesign: null
                                           })}
                                           deleteOnClick={this.deleteDesigns}/>
                        <DownloadAllDesignsModal show={this.state.displayDownloadAllDesignsModal} onHide={this.hideDownloadAllDesignsModal} folders={this.state.folders} currFolder={this.props.match.params.folder_id}/>
                        <ShareLinkModal 
                            show_share_modal={this.state.show_share_modal}
                            hide_share_modal={() => this.setState({ show_share_modal: false, activeDesign: null })}
                            design_id={this.state.activeDesign}
                            is_saved_design
                        />
                        <this.CreateFolderModal/>
                        <this.CreateDesignFolderModal/>
                        <this.RenameFolderModal/>
                        <this.DeleteFolderModal/>
                        {this.props.match.params.folder_id ? <this.FolderView/> : <this.FolderHomeView/>}
                    </div>
                ))

    }
}

const mapStateToProps = function (state) {
    return {
        user: state.user,
    }
};

const mapDispatchToProps = dispatch => ({
    fetch_owned_designs: () => dispatch(fetch_owned_designs())
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Folders))